<style scoped>
h3 {
  /* font-size: 5em; */
  text-align: center;
  margin-top: 150px;
}
.container {
  padding-top: 64px;
  padding-bottom: 64px;
  height: 60vh;
}
</style>

<template lang="pug">
.container.light-gray.text-center
  h3
    small.text-muted.center This page is restricted! {{ isValidUser }}
    br
    small.text-muted.center Please sign in.
</template>
<script>
export default {
  meta: {
    title: 'Restricted',
  },
  computed: {
    isValidUser() {
      let user = this.$store.state.auth.user
      return user
      // if (user) {
      //   if(user.type === 'reseller') {
      //     if (user.status === 'disabled' || user.status === 'application') {
      //       return false;
      //     } else {
      //       return true;
      //     }
      //   } else {
      //       return true;
      //   }
      // }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-restricted.vue